import { atom } from "jotai";
import { INIT_PAYLOAD } from "../constants";
import { Payload } from "../types";

const sendOtpPayloadAtom = atom<Payload<any>>(INIT_PAYLOAD);
export { sendOtpPayloadAtom };
